import Footer from "components/sections/footer"
import Header from "components/sections/headerV2"
import Seo from "components/sections/seo"
import { graphql } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import { getCorporationSchema, getSchemaWithFallback } from "../../utils/schemaHelpers"
import Template from "./template"

const TemplateContainer = ({ data: { footer, header, template } }) => {
  const fallbackSchema = getCorporationSchema()
  
  // Use Contentful json if present, otherwise use fallback
  const schema = getSchemaWithFallback(template.meta?.json, fallbackSchema)

  return (
    <>
      <Seo
        {...template.meta}
        id={template.id}
        schemaMarkup={schema}
        slug={template.slug}
      />
      <Header {...header} />
      <Template {...template} />
      <Footer {...footer} />
    </>
  )
}

TemplateContainer.props = {
  ...Template.props,
  meta: PropTypes.shape(Seo.props),
}

TemplateContainer.propTypes = {
  data: PropTypes.shape({
    footer: PropTypes.shape(Footer.props),
    header: PropTypes.shape(Header.props),
    template: PropTypes.shape(TemplateContainer.props),
  }),
}

export default TemplateContainer

export const query = graphql`
  fragment ButtonV2Fields on ContentfulComponentButtonV2 {
    id
    accessibilityLabel
    showArrow
    buttonSize
    buttonStyle
    path
    text
  }
  fragment ImageFields on ContentfulAsset {
    title
    description
    file {
      url
    }
  }
  query ConditionsTemplate($slug: String) {
    header: contentfulGlobalHeader(name: { eq: "Header" }) {
      announcement {
        json
      }
      menu {
        menus {
          label
          links {
            text
            path
            nestedLinks {
              text
              path
            }
          }
        }
      }
      utilityLinks {
        path
        text
      }
      cta {
        href: path
        text
      }
      callsToAction {
        ...ButtonV2Fields
      }
    }
    footer: contentfulGlobalFooter(name: { eq: "Footer" }) {
      menu {
        menus {
          label
          links {
            path
            text
          }
        }
      }
      scheduleAppointment {
        path
        text
      }
      socialLinks {
        path
        text
      }
      utilityLinks {
        path
        text
      }
    }
    template: contentfulConditionsTemplate(slug: { eq: $slug }) {
      slug
      title
      meta: seoMetadata {
        canonical
        keywords
        title
        type
        json
        abstract {
          abstract
        }
        description {
          description
        }
        image {
          file {
            url
          }
        }
      }
      sections {
        __typename
        ... on ContentfulSectionCards {
          __typename
          headline
          subheadline
          actions {
            buttonText
            style
            action {
              __typename
              ... on ContentfulActionRedirect {
                __typename
                url
                openInANewTab
              }
            }
          }
          cards {
            action {
              action {
                __typename
                ... on ContentfulActionRedirect {
                  __typename
                  url
                  openInANewTab
                }
              }
            }
            title
            description {
              description
            }
            icon {
              file {
                url
              }
              title
              description
            }
          }
        }
        ... on ContentfulSectionRichText {
          __typename
          title
          alignment
          isCollapsible
          details {
            json
          }
          backgroundImage {
            file {
              url
            }
          }
        }
        ... on ContentfulSectionWrapper {
          __typename
          backgroundStyle
          title
          wrapperSections: sections {
            __typename
            ... on ContentfulSectionSideBySide {
              __typename
              name
              style
              customClass
              sections {
                __typename
                ... on ContentfulSectionRichText {
                  __typename
                  title
                  alignment
                  isCollapsible
                  details {
                    json
                  }
                  backgroundImage {
                    file {
                      url
                    }
                  }
                }
              }
            }
            ... on ContentfulSectionRichText {
              __typename
              title
              alignment
              isCollapsible
              details {
                json
              }
              backgroundImage {
                file {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
